import * as RasaModal from '../modal'

export const IMAGE_IMPORT_SERVER_RESOURCE = '/settings-upload'

export const emptyModalImageData = RasaModal.emptyFileModalData



// WEBPACK FOOTER //
// ./src/components/image/constants.ts